/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:48 PM
 *
 */

import React, { useRef } from 'react';
import ReactExport from 'react-export-excel';
import { useReactToPrint } from 'react-to-print';
import omit from 'lodash/omit';
import moment from 'moment';

import { Member, MemberTestList } from 'features/members/types';
import { getSubTestList } from 'features/members/utils/getSubTestList';
import { utcDateToLocal } from 'features/members/utils/utcDateToLocal';

import Button from 'components/Button';
import ProfileTestPrint from 'features/members/components/others/ProfileTestPrint';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

interface IProfileTestExport {
  testList: MemberTestList;
  selectedMember: Member;
}

const ProfileTestExport = ({ testList, selectedMember: currentMember }: IProfileTestExport) => {
  const componentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  const excelData =
    Object.keys(testList).length !== 0
      ? testList.list.map((element) => {
          return Object.assign(
            {},
            {
              test_name: element.test_name,
              test_app: element.app_slug,
              temperature: element.temperature,
              test_date: moment(utcDateToLocal(element.test_date)).format('YYYY/MM/DD'),
            },
            ...element.report.map((sub) => ({
              [sub.name]: sub.value,
              note: sub.note.length === 0 ? 'N/A' : sub.note.join(' | '),
            }))
          );
        })
      : [];

  return (
    <div className="flex gap-2">
      <ProfileTestPrint
        test_name={testList.list[0].test_name}
        test={getSubTestList(testList.list)}
        member={currentMember}
        ref={componentRef}
      />
      <Button onClick={handlePrint} size="sm">
        Print
      </Button>
      <ExcelFile
        element={<Button size="sm">Export to Excel</Button>}
        filename={testList.list[0].test_name}
      >
        <ExcelSheet data={excelData} name={testList.list[0].test_name}>
          {Object.keys(omit(excelData[0], 'note')).map((element: any, index: number) => {
            return <ExcelColumn key={index} label={element} value={element} />;
          })}
          <ExcelColumn label="Test Note" value="note" />
        </ExcelSheet>
      </ExcelFile>
    </div>
  );
};

export default ProfileTestExport;
